import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IResponse } from '../../../../core/interfaces/IResponse';
import { ApiService } from '../../../../core/services/ApiService';
import { IVoucherAndCard } from '../interfaces/IVoucherAndCard';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  private readonly _basePath = '/products';
  private readonly _apiService = inject(ApiService);

  public getProductsByNumber(number: string): Observable<IResponse<IVoucherAndCard>> {
    return this._apiService.get(`${this._basePath}/by-number?number=${number}`);
  }
}
